export const translations = {
  en: {
    title: "Cultiv.ai - Leaf Diagnosis",
    chooseFile: "Choose Image",
    selectPlant: "Select a plant type",
    otherOption: "Other",
    useAI: "Use AI Plant Recognition",
    submit: "Analyze Leaf",
    analyzing: "Analyzing...",
    previewText: "Image preview will appear here",
    resultsTitle: "AI Analysis Results",
    skipSegmentation: "Skip segmentation",
    modelSam: "Segmentation model: SAM",
    modelSam2: "Segmentation model: SAM2",
    modelSam3: "Segmentation model: SAM3",
    modelFastSam: "Segmentation model: FastSAM",
    modelYolo: "Segmentation model: YOLO",
    modelLangSam: "Segmentation model: LangSAM",
    disclaimer:
      "Each result below is provided by a different expert system. These are probabilistic predictions and may not be 100% accurate. Different experts might provide slightly different or even contradictory results. Please use these predictions as guidance and exercise caution when making decisions based on them.",
    expert1: "Expert 1 (Health Status):",
    expert2: "Expert 2 (Plant Type):",
    expert3: "Expert 3 (Pathogens):",
    expert4: "Expert 4 (Disease):",
    expert5: "Expert 5 (Symptoms):",
    plantType: "Plant Type:",
    healthStatus: "Health Status:",
    likelyDisease: "Likely Disease:",
    probablePathogens: "Probable Pathogens:",
    possibleSymptoms: "Possible Symptoms:",
    unsupportedPlantNote:
      "Note: The model wasn't trained for this plant type. Results may be inaccurate.",
    leavesDetected: "Leaves Detected",
    diseasedLeaves: "Diseased Leaves",
    healthy: "Healthy",
    sick: "Sick/Diseased",
    noLeavesDetected: "No leaves were detected in the image.",
    notAvailable: "N/A",
    errorPrefix: "Error",
    unknownError: "An unknown error occurred.",
  },
  pt: {
    title: "Cultiv.ai - Diagnóstico de Folha",
    chooseFile: "Escolher arquivo",
    selectPlant: "Selecione um tipo de planta",
    otherOption: "Outro",
    useAI: "Usar Reconhecimento IA de Planta",
    submit: "Analisar Folha",
    analyzing: "Analisando...",
    previewText: "A prévia da imagem aparecerá aqui",
    resultsTitle: "Resultados da análise de IA",
    skipSegmentation: "Pular segmentação",
    modelSam: "Modelo de segmentação: SAM",
    modelSam2: "Modelo de segmentação: SAM2",
    modelSam3: "Modelo de segmentação: SAM3",
    modelFastSam: "Modelo de segmentação: FastSAM",
    modelYolo: "Modelo de segmentação: YOLO",
    modelLangSam: "Modelo de segmentação: LangSAM",
    disclaimer:
      "Cada resultado abaixo é fornecido por um sistema especialista diferente. Estas são previsões probabilísticas e podem não ser 100% precisas. Diferentes especialistas podem fornecer resultados ligeiramente diferentes ou até contraditórios. Por favor, use estas previsões como orientação e tenha cautela ao tomar decisões baseadas nelas.",
    expert1: "Especialista 1 (Estado de Saúde):",
    expert2: "Especialista 2 (Tipo de Planta):",
    expert3: "Especialista 3 (Patógenos):",
    expert4: "Especialista 4 (Doença):",
    expert5: "Especialista 5 (Sintomas):",
    plantType: "Tipo de planta:",
    healthStatus: "Estado de saúde:",
    likelyDisease: "Provável doença:",
    probablePathogens: "Prováveis patógenos:",
    possibleSymptoms: "Possíveis sintomas:",
    unsupportedPlantNote:
      "Nota: O modelo não foi treinado para este tipo de planta. Os resultados podem ser imprecisos.",
    leavesDetected: "Folhas Detectadas",
    diseasedLeaves: "Folhas Doentes",
    healthy: "Saudável",
    sick: "Doente/Com Doença",
    noLeavesDetected: "Nenhuma folha foi detectada na imagem.",
    notAvailable: "N/D",
    errorPrefix: "Erro",
    unknownError: "Ocorreu um erro desconhecido.",
  },
};
